<template>
  <div style="margin:30px;">
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="密码：" placeholder="请输入密码"> 
                <el-input v-model="form.password" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" placeholder="请再次输入密码"> 
                <el-input v-model="form.checkPass" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="confirm" :loading="loadingFlag">确定</el-button>
            </el-form-item>
        </el-form>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    data(){
        return{
            form:{
                password:"",
                checkPass:"",
            },
            uid:"",
            loadingFlag:false
        }
    },
    created(){
        this.uid = sessionStorage.getItem("uid")
    },
    methods:{
        async confirm(){
            if(!this.form.password){
                this.$message.error('请输入密码')
                return false
            }
            if(!this.form.checkPass){
                this.$message.error("请确认密码")
                return false
            }
            if(this.form.password != this.form.checkPass){
                this.$message.error("两次密码输入不一致")
                return false
            }
            this.loadingFlag = true
            const res = await axios.post('https://xlogin.us/api/my_update_pwd.php',qs.stringify({uid:this.uid,password:this.form.password}))
            if(res.data.code === 200 ){
                this.$message.success(res.data.msg)
                this.loadingFlag = false
            }else{
                this.$message.error(res.data.msg)
                this.loadingFlag = false
            }
        }
    }
}
</script>

<style lang="less" scoped>
.el-input{
    width: 300px;
}
</style>